import React from 'react';
import { useSelector } from 'react-redux';

import MenuItem from './Item';

import * as S from './styled';

const Menu = () => {

  const admin = useSelector(state => state.user.profile.admin);

  const regUser = admin ?  <MenuItem to="/signup">Cadastrar Usuário</MenuItem> : null;

  return(
    <S.MenuWrapper>
      <MenuItem to="/search">Consultar pessoa</MenuItem>
      <MenuItem to="/register">Cadastrar pessoa</MenuItem>
      { regUser }
    </S.MenuWrapper>
  );
}

export default Menu;